import { Dialog } from "@headlessui/react";
import { useForm } from "react-hook-form";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { Groups } from "../../model/Groups";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";
import { ConstMessage } from "../../config/const";
import { Spiner } from "../../components/spinner/Spiner";

export type GroupAdminSettingModallProps = {
  group?: Groups;
  cols: GridCol[];
  rows: GridRow[];
  onClickSubmit: (group: Groups, updatedUsers: GridRow[]) => Promise<void>;
  firstPageFlg?: boolean;
  setFirstPageFlg?: Function;
  pagingFunc?: (ver: number) => void;
  totalCount?: number;
  isLode?: boolean;
  isUpdateLode?: boolean;
}

export const GroupAdminSettingModal = ({
  open,
  toggle,
  closeOnClickOutside,
  group,
  cols,
  rows,
  onClickSubmit,
  firstPageFlg = false,
  setFirstPageFlg,
  pagingFunc,
  totalCount,
  isLode = false,
  isUpdateLode = false,
}: ModalProp & GroupAdminSettingModallProps) => {

  const { handleSubmit } =
    useForm<Groups>({
      defaultValues: group,
    });

  const handleFormSubmit = async (data: Groups) => {
    if (group) {
      await onClickSubmit(group, rows);
    }
  };

  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:w-full max-w-screen-md">
          
          {/* 背景グレーアウト＋ローディング表示 */}
          {isUpdateLode && (
            <div className="absolute inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
              <Spiner />
            </div>
          )}

          <div className="px-2 pb-4 sm:p-4">
            <div className="sm:mt-3">
              <Dialog.Title
                as="h3"
                className="text-left text-lg font-medium leading-6 text-gray-900 flex items-center"
              >
                <div className="mb-1 block">管理者設定</div>
              </Dialog.Title>
              <Dialog.Description className={"pl-3 pt-2 text-red-500"}>
                {ConstMessage.MSG_IF_GROUPADMIN_ISNOT_SET}
              </Dialog.Description>
              <div className="overflow-y-auto">
                <div className="px-2 text-left pb-8 h-[500px]">
                  {isLode ? (
                    <Spiner />
                  ) : (
                    <div className={"pt-4"}>
                      <TableList 
                        header 
                        gridCol={cols} 
                        gridRow={rows}
                        firstPageFlg={firstPageFlg}
                        setFirstPageFlg={setFirstPageFlg}
                        pagingFunc={pagingFunc}
                        gridRowLength={totalCount}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={"キャンセル"}
            />
            <Button
              className="mt-1 w-[132px]"
              onClick={handleSubmit(handleFormSubmit)}
              children={"登録"}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      </Modal>
    </>
  )
}